import React from 'react';

const ChannelEditorialRoles = () => {
  return (
    <React.Fragment>
      <h1>Roles and Ressponsiblities</h1>

      <h1>Channel Roles</h1>

      <p>
        There are three channel roles: Channel Administrators (Channel Admins), Channel Curators and Channel Screeners. The journal editorial staff conducts and manages editorial and peer review independently of the channel.
      </p>
      <p>
        <strong>Channel Admins <i>(Academic Channels only)</i></strong> are responsible for managing the channel. This includes curating content on the channel homepage via widgets (found on the Design page) and adding/managing Channel Curators. Channel Admins possessing the appropriate medical expertise may also check articles during the first and second channel preview steps detailed below. Channel Admins work closely with Cureus Admins to keep their channel running efficiently.
      </p>
      <p>
        <strong>Channel Curators <i>(Academic Channels only)</i></strong> ensure that all article submissions are within scope and adhere to Cureus author guidelines. Channel Curators also assist authors in strengthening their manuscripts prior to the rigorous editorial review conducted by independent Cureus editors. All peer-reviewed submissions must receive final approval by an independent Cureus associate editor in order to be published in Cureus.
      </p>
      <p>
        <strong>Channel Screeners <i>(Academic (Non-subscription) and Commercial Channels only)</i></strong> check new article submissions to ensure the author is eligible to submit through the channel and that the topic is within the channel’s scope. They cannot defer articles for revisions and are not involved in the publication process outside of determining if the article was correctly submitted to the channel.
      </p>
    </React.Fragment>
  )

}

export default ChannelEditorialRoles;